// extracted by mini-css-extract-plugin
module.exports = {"navBar":"styles_navBar__131W3","footer":"styles_footer__3o_o0"};